import { useAIMode } from '@/contexts/AIModeContext';
import { Switch } from '@/components/ui/switch';
import { Badge } from '@/components/ui/badge';
import { Brain, Lock, Sparkles } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';

export function AIToggle() {
  const { aiEnabled, aiToggle, setAiToggle, tierSupportsAI, tier, serviceLevel, setServiceLevel, canUsePremium } = useAIMode();

  if (!tierSupportsAI) {
    return (
      <Tooltip>
        <TooltipTrigger asChild>
          <div className="flex items-center gap-1.5 px-2 py-1 rounded-md bg-sidebar-foreground/5 cursor-not-allowed">
            <Lock className="h-3 w-3 text-sidebar-foreground/40" />
            <span className="text-[11px] text-sidebar-foreground/40 font-medium">AI</span>
            <Badge variant="outline" className="text-[9px] h-4 px-1 border-sidebar-foreground/20 text-sidebar-foreground/40">
              PRO
            </Badge>
          </div>
        </TooltipTrigger>
        <TooltipContent side="bottom" className="text-xs">
          Upgrade to Pro to enable AI features
        </TooltipContent>
      </Tooltip>
    );
  }

  return (
    <div className="flex items-center gap-1.5 px-2 py-1 rounded-md bg-sidebar-foreground/5">
      <Brain className={`h-3 w-3 ${aiEnabled ? 'text-success' : 'text-sidebar-foreground/40'}`} />
      <span className={`text-[11px] font-medium ${aiEnabled ? 'text-sidebar-foreground' : 'text-sidebar-foreground/40'}`}>
        AI
      </span>
      <Switch
        checked={aiToggle}
        onCheckedChange={setAiToggle}
        className="h-4 w-7 data-[state=checked]:bg-success"
      />

      {/* Premium AI toggle — Enterprise only */}
      {canUsePremium && aiEnabled && (
        <Tooltip>
          <TooltipTrigger asChild>
            <button
              onClick={() => setServiceLevel(serviceLevel === 'standard' ? 'premium' : 'standard')}
              className={`flex items-center gap-1 ml-1 px-1.5 py-0.5 rounded text-[10px] font-semibold transition-colors ${
                serviceLevel === 'premium'
                  ? 'bg-warning/20 text-warning border border-warning/30'
                  : 'bg-sidebar-foreground/5 text-sidebar-foreground/50 border border-transparent hover:border-sidebar-foreground/20'
              }`}
            >
              <Sparkles className="h-2.5 w-2.5" />
              {serviceLevel === 'premium' ? 'PRO AI' : 'STD'}
            </button>
          </TooltipTrigger>
          <TooltipContent side="bottom" className="text-xs max-w-[200px]">
            {serviceLevel === 'premium'
              ? 'Premium AI active — higher accuracy, 14× rate. Click to switch to Standard (7×).'
              : 'Standard AI — 7× rate. Click to switch to Premium (14× rate, higher accuracy).'}
          </TooltipContent>
        </Tooltip>
      )}
    </div>
  );
}
